const config = {
  paginationPerPage: 25,
  mockEnabled: false,
}

export default config